"use client";
import SvgTaskFilled from "./task-filled.svg.js";
import SvgTaskOutlined from "./task-outlined.svg.js";
import SvgTaskRound from "./task-round.svg.js";
import SvgTaskSharp from "./task-sharp.svg.js";
const task = {
  filled: SvgTaskFilled,
  outlined: SvgTaskOutlined,
  round: SvgTaskRound,
  sharp: SvgTaskSharp
};
export {
  task
};
